import { useCellulaI18nProviderContext } from '../../components/i18n_provider/i18n_provider.context';

export interface CellulaTexts {
	'Common.Close': string;
	'Common.Download': string;
	'Common.UnknownError': string;
	'Component.DialogAlert.ButtonAbort.DisabledText': string;
	'Component.FileViewer.FileCounter.Label': string;
	'Component.FileViewer.FileCounter.Of': string;
	'Component.FileViewer.Download': string;
	'Component.FileViewer.NextItem': string;
	'Component.FileViewer.PreviousItem': string;
	'Component.InputSelect.Placeholder': string;
	'Component.Form.UnknownSubmitError': string;
	'Component.Form.GeneralInputError': string;
	'Component.FormSubmitButton.NotDirty': string;
	'Component.FormSubmitButton.Invalid': string;
	'Component.InputPhoneNumber.CountrySelectLabel': string;
	'Component.InputPhoneNumber.InputLabel': string;
	'Component.Label.Optional': string;
	'Component.Attachment.DeleteTooltip': string;
	'Component.Attachment.DeleteUnspecifiedError': string;
	'Component.InputRating.OneStar': string;
	'Component.InputRating.SeveralStars': string;
	'Component.InputCombobox.Loading': string;
	'Component.InputCombobox.Placeholder': string;
	'Component.InputCombobox.Empty': string;
	'Component.InputCombobox.SelectAll': string;
	'Component.InputCombobox.ClearAll': string;
	'Component.InputCombobox.MultipleSelectedValue': string;
	'Component.Table.SortByColumn': string;
	'Component.Table.SortByThisColumn': string;
	'Component.Table.ScrollableRegion': string;
	'Component.Table.ScrollableRegionUnnamed': string;
	'Component.Table.EmptyState': string;
	'Component.Table.Loading': string;
	'Component.TableColumnMenu.Trigger': string;
	'Component.TableColumnMenu.ToggleColumn': string;
	'Component.TableColumnMenu.ReorderColumn': string;
	'Component.TableColumnMenu.MovedAnnouncement': string;
	'Component.Pagination.PreviousPage': string;
	'Component.Pagination.NextPage': string;
	'Component.Pagination.Previous': string;
	'Component.Pagination.Next': string;
	'Component.Pagination.Page': string;
}

export type useTextReturn = (key: keyof CellulaTexts, replaceArguments?: { [key: string]: string } | null) => string;

export function useText(): useTextReturn {
	const { texts } = useCellulaI18nProviderContext();

	function handleTranslate(key: keyof CellulaTexts, replaceArguments: { [key: string]: string } | null = null): string {
		if (!texts)
			throw new Error(
				"No translation texts where found. It seems that we are not in CellulaI18nProvider's context. useText() must be used within a CellulaI18nProvider.",
			);

		let translation = texts?.[key];

		if (replaceArguments) {
			for (const replace in replaceArguments) {
				translation = translation.replace(`{{${replace}}}`, replaceArguments[replace]);
			}
		}

		return translation;
	}

	return handleTranslate;
}
